/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

/**
 * @param {FormReducerDraftState} state 
 */
export function GetQuestionFactory (state) {

    /**
     * @param {string} guid 
     */
    return function (guid) {
        const question = state.form.questions.find(
            (q) => q.guid === guid
        );

        return question;
    };
}
